import {MiniInfo, ExtendedObject} from './info';
// [path[], module, appId]
export type LinkDescribe = [string[], string] | [string[], string, string] | [string[], string, object] | [string[], string, string, object];

export interface LinkIterableIterator<Ext extends ExtendedObject = {user: object}>  {
	(path: string[], info?: MiniInfo<Ext>, restful?: object): IterableIterator<LinkDescribe>;
};
//虚拟路径链接生成器列表，形如：
// `${path}@${appId}`: *(path) => [[...vpath], path, appId]
export type LinkList<Ext extends ExtendedObject = {user: object}> = { [key: string]: LinkIterableIterator<Ext> };
export interface set<Ext extends ExtendedObject = {user: object}> {
	/**
	 * 设置连接器
	 * @param link 连接函数
	 * @param path 路径
	 * @param appId 应用ID
	 */
	(link: LinkIterableIterator<Ext>, path: string, appId?: string): void;
}
export interface remove {
	/**
	 * 移除连接器
	 * @param path 路径
	 * @param appId 应用ID
	 */
	(path: string, appId?: string): void;
}
export interface get<Ext extends ExtendedObject = {user: object}> {
	/**
	 * 获取连接器
	 * @param path 路径
	 * @param appId 应用ID
	 */
	(path: string, appId?: string): LinkIterableIterator<Ext> | undefined;
}

const list: LinkList = {};
/**
 * 设置连接器
 * @param link 连接函数
 * @param path 路径
 * @param appId 应用ID
 */
export function set<Ext extends ExtendedObject = {user: object}>(this: void | LinkList<Ext>, link: LinkIterableIterator<Ext>, path: string, appId?: string): void {
	if (typeof link !== 'function') {
		return;
	}
	const links = this || list;
	links[appId ? path + '@' + appId : path] = link;
}

/**
 * 移除连接器
 * @param path 路径
 * @param appId 应用ID
 */
export function remove<Ext extends ExtendedObject = {user: object}>(this: void | LinkList<Ext>, path: string, appId?: string): void {
	const links = this || list;
	delete links[appId ? path + '@' + appId : path];
}

/**
 * 获取连接器
 * @param path 路径
 * @param appId 应用ID
 */
export function get<Ext extends ExtendedObject = {user: object}>(this: void | LinkList<Ext>, path: string, appId?: string): LinkIterableIterator<Ext> | undefined {
	path = appId ? `${path}@${appId}` : path;
	const links = this || list;
	if (path in links) {
		return links[path];
	}
}

interface LinkApi<Ext extends ExtendedObject = {user: object}> {
	/** 设置连接器 */
	set: set<Ext>,
	/** 移除连接器 */
	remove: remove,
	/** 获取连接器 */
	get: get<Ext>,
}
function LinkApi<Ext extends ExtendedObject = {user: object}>(links: LinkList<Ext> = {}): LinkApi<Ext> {
	return {
		set: set.bind(links),
		remove: remove.bind(links),
		get: get.bind(links),
	}
}
export type api<Ext extends ExtendedObject = {user: object}> = LinkApi<Ext>;
export default LinkApi;
